import { EXTERNAL_ITEM_REFERENCE_API_V2_URLS } from "@/programs/urls";
import {
  restfulShowPaginated,
  restfulCreate,
  restfulShow,
} from "@/programs/services/ServiceHelpers.ts";
import { labelsToOptions } from "@/programs/utils/constants.ts";

export enum ExternalReferenceSource {
  ECoach = "ecoach",
}
export const REFERENCE_SOURCE_LABELS: Record<ExternalReferenceSource, string> =
  {
    [ExternalReferenceSource.ECoach]: "ECoach",
  };

export enum ExternalReferenceType {
  CourseGrade = "course_grade",
  AssignmentGrade = "assignment_grade",
  CourseRoster = "course_roster",
}
export const REFERENCE_TYPE_LABELS: Record<ExternalReferenceType, string> = {
  [ExternalReferenceType.CourseGrade]: "Course Grade",
  [ExternalReferenceType.AssignmentGrade]: "Assignment Grade",
  [ExternalReferenceType.CourseRoster]: "Course Roster",
};
export const REFERENCE_TYPE_OPTIONS = labelsToOptions(REFERENCE_TYPE_LABELS, [
  ExternalReferenceType.AssignmentGrade,
]);

export interface ExternalItemReference {
  id: number;
  referenceSource: ExternalReferenceSource;
  referenceType: ExternalReferenceType;
  referenceValues: {
    termCode?: string;
    courseCode?: string;
    assignmentId?: string;
  };
}

export type ExternalItemReferenceCreatePayload = Omit<
  ExternalItemReference,
  "id"
>;

export interface ExternalItemReferenceOption {
  id: number;
  label: string;
  referenceType: ExternalReferenceType;
}

interface CollectionURLParams {
  programId: number;
}

export const getExternalItemReferences = restfulShowPaginated<
  CollectionURLParams,
  ExternalItemReference[]
>(EXTERNAL_ITEM_REFERENCE_API_V2_URLS.index);

export const createExternalItemReference = restfulCreate<
  CollectionURLParams,
  ExternalItemReference,
  ExternalItemReferenceCreatePayload
>(EXTERNAL_ITEM_REFERENCE_API_V2_URLS.index);

export const getExternalItemReferenceOptions = restfulShow<
  CollectionURLParams,
  ExternalItemReferenceOption[]
>(EXTERNAL_ITEM_REFERENCE_API_V2_URLS.options);
